import React from 'react';

import ArrowSvg from 'assets/images/arrow.svg';

import BaseIcon from './BaseIcon';

const ArrowIcon = props => (
  <BaseIcon {...props} src={ArrowSvg} />
);

export default ArrowIcon;
